import { Card,  CardContent, CardHeader, CardHeaderProps, Divider, ButtonProps as MuiButtonProps, Typography} from '@mui/material'
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router';
import { Iconify } from 'src/components/iconify';
import UpdateButton, { UpdateButtonProps } from 'src/components/reusable/custom-edit-button';
import DailogPopup from 'src/layouts/components/dailog';
import { useStore } from 'src/store/StoreContext';
import { createLinearGradient, hexToRgbChannel } from 'src/theme/styles';

interface StepContainerProps extends UpdateButtonProps {
  headerProps?: CardHeaderProps;
  children?: React.ReactElement | React.ReactElement[];
  title?: string;
  icon?:string;
  isDivider?: boolean;
  isColumn?: boolean;
  isHideAction?:boolean;
}

const StepContainer: React.FC<StepContainerProps> = observer((props:StepContainerProps) => {
  const { isDivider = true,isHideAction= false } = props;
  const service = useStore()?.service;
  const [open, setopen] = useState(false);

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isMobile = searchParams.get('ismobile') === 'true';

  const onCancel =() =>{
    if(service?.step !== 0){
      service?.goBack();
    }else{
      setopen(true);
    }
  }

  const onSubmit =()=>{
    service?.reset();
    setopen(false);
    
    // If ismobile=true, navigate to mobile app login screen
    if (isMobile) {
      try {
        window.location.href = 'primetelehealth://login';
        // Fallback: close window after a delay if app doesn't open
        setTimeout(() => {
          window.close();
        }, 1000);
      } catch (error) {
        console.error('Error navigating to mobile app:', error);
        // Fallback to home
        navigate('/');
      }
    } else {
      if(location.href.includes('patient')){
        navigate('/patient/Services');
      }else{
        navigate('/');
      }
    }
  }

  return (
    <Card 
    elevation={4}>
       {props.title && <CardHeader
       sx={{
        backdropFilter: 'blur(6px)',
        WebkitBackdropFilter: 'blur(6px)',
        py:2,
        backgroundImage: (theme) => createLinearGradient(hexToRgbChannel(theme.palette.primary.light,true),hexToRgbChannel(theme.palette.primary.light,true), 0.4, 0.2, 270)
       }}
        avatar={props.icon &&
         <Iconify  width={30} icon={props.icon}/>
        }
        title={props.title}
        {...props.headerProps}
      />}
      {isDivider && <Divider />}
     <CardContent sx={{minHeight:300}}>
        {props.children}
      </CardContent>
      {(isDivider && !isHideAction) && <Divider/>}
    {!isHideAction && 
    <UpdateButton {...props} cancelButtonProps={{onClick:onCancel}} />}
    <DailogPopup open={open} confirmTitle='Confirm'  onCancel={() => setopen(false)} onSubmit={onSubmit}>
          <Typography variant='h6' p={2} color='textSecondary'>
            {'Are you sure to cancel the process?'}
          </Typography>
    </DailogPopup>
    </Card>
  );
});

export default StepContainer;